const activityLog = {
  title: "Activity Log",
  searchPlaceholder: "Search by Actor Name",
  // Super Admin Full Logs — the API searches actor and company names.
  adminSearchPlaceholder: "Search by actor or company",
  exportAll: "Export All",
  filters: {
    module: "Module",
    company: "Company",
    dateRange: "Date range",
  },
  columns: {
    time: "Time",
    actor: "Performed By",
    company: "Company",
    action: "Action",
    module: "Module",
  },
  showingRange: "Showing {from}-{to} of {total} entries",
  // No entries at all (nothing searched / filtered).
  noActivity: {
    title: "No activity yet",
    description:
      "Actions taken across companies, events, and requests will appear here as they happen.",
  },
  empty: {
    title: "No matching activity",
    description: "No activity matches your search or filters.",
    clear: "Clear filters",
  },
  exportModal: {
    title: "Export Activity Log",
    description:
      "Choose the fields to include in your file. At least one field must be selected.",
    selectAll: "Select all fields",
    confirm: "Confirm Export",
  },
  exportFields: {
    time: "Time",
    actorName: "Actor Name",
    actorRole: "Actor Role",
    company: "Company",
    action: "Action",
    module: "Module",
  },
  exportFileName: "activity-log",
  // Company portal screen — only what differs from the admin one.
  company: {
    filters: {
      role: "Role",
      companyOwner: "Company Owner",
    },
    noActivityDescription:
      "Actions taken in this company will appear here as they happen.",
  },
};

export default activityLog;
